































import {
    Vue, Component, Prop, PropSync, Mixins, Watch,
} from 'vue-property-decorator'
import util from '@/util'

let querySearch = util.debounce(function (value) {
    // console.log('querySearch 111')
    if (String(value).length < this.length) {
        this.dataList = []
        return
    }
    // console.log('querySearch 222')
    this.getListByValue(value, 1).then(list => {
        this.dataList = list
    })
}, 0)

@Component
export default class Autocomplete extends Vue {
    @Prop({default: ''}) value!: string         // 组件v-model绑定的值

    @Prop({default: ''}) obj!: any              // 下拉框的v-model对象

    @Prop({default: ''}) idKey!: string         // 下拉列表的id的字段

    @Prop({default: ''}) nameKey!: string       // 下拉列表的name的字段

    @Prop({default: ''}) showIdKey!: string

    @Prop({default: ''}) size!: string

    @Prop({default: 1}) length!: number         // 最少输入几个字符时搜素

    @Prop({default: false}) showId!: boolean    // 是否显示id

    @Prop({default: false}) multiple!: boolean  // 是否多选

    @Prop({default: true}) clearable!: boolean

    @Prop({default: false}) isPeanutId!: boolean

    @Prop({
        required: true,
        default() {
            return () => {
                Promise.resolve({})
            }
        },
    }) fn!: Function            // 查询下来列表的函数

    @Prop({
        default() {
            return {}
        },
    }) params!: any             // 查询下拉列表的参数
    
    @Prop({
        default() {
            return () => {
            }
        }
    }) paramFormater!: Function // 处理最后查询参数

    @Prop({default: 'id'}) queryKey!: string        // 输入值在查询参数中的字段

    @Prop({ default: '' }) initKey!: string // 组件初始化时，如果value已经有值，可能需要根据id来查询name

    @Prop({default: ''}) listKey!: string           // 下拉列表在接口中返回的字段

    @Prop({default: false}) disabled!: boolean

    @Prop({
        default() {
            return () => {
            }
        }
    }) disableFn!: Function // 禁用option的函数

    // 是否禁用
    @Prop({default: ''}) placeholder!: string       // placeholder

    state: any = ''             // 下拉框的el-model对象

    dataList: any[] = []        // 下拉列表数组

    loading: boolean = false    // 是否正在加载下拉列表

    currentValue: any = ''

    @Watch('value', {immediate: true})
    async onValueChange(newVal) {                   // value改变同步时修改state
        if (newVal == null || newVal === '') {
            this.state = this.multiple ? [] : ''
            return
        }
        if (this.multiple) {        // 多选
            this.state = this.state || []
            let state: any[] = []
            let arr = newVal.filter(item => {   // 收集
                let temp = this.state.find(v => ((this.idKey ? v[this.idKey] : v) === item))
                if (temp) {
                    state.push(temp)
                }
                return !temp
            })

            if (arr) {
                arr.forEach(async item => {
                    let list = await this.getListByValue(item, 2, true)
                    this.dataList.unshift(...list)
                    let obj = list.find(v => (this.idKey ? v[this.idKey] : v) === item)
                    if (obj) {
                        state.push(obj)
                    } else {
                        state.push(item)
                    }
                })
            }
            this.state = state
        } else {
            this.state = this.state || ''
            if (newVal !== (this.idKey ? this.state[this.idKey] : this.state)) {
                let list = await this.getListByValue(newVal, 2, true)
                this.dataList = list
                this.state = list.find(v => (this.idKey ? v[this.idKey] : v) === newVal) || ''
                if (this.isPeanutId) {
                    this.state = list.find(v => (v.peanutId) === newVal) || ''
                }
            }
        }
    }

    @Watch('state')
    onStateChange() {
        const state = util.cloneDeep(this.state)
        this.$emit('update:obj', state)
        this.$emit('stateChange', state)
    }

    cancelReadOnly() {
        setTimeout(() => {
            (this.$refs.select as any).$refs.reference.$refs.input.readOnly = false
        }, 500)
    }

    clearList() {
        this.dataList = []
    }

    changeState(newVal) {
        if (this.multiple) {
            if (newVal && Array.isArray(newVal)) {
                this.currentValue = newVal.map(v => (this.idKey ? v[this.idKey] : v))
            }
        } else {
            this.currentValue = (newVal && (this.idKey ? newVal[this.idKey] : newVal) != null) ? (this.idKey ? newVal[this.idKey] : newVal) : ''
        }
        this.$emit('input', this.currentValue)
        this.$emit('change', newVal)
    }

    getListByValue(value, source, isInit = false):any {
        if (!isInit && String(value).length < this.length) {
            this.dataList = []
            return
        }
        this.loading = true
        let params = isInit && this.initKey ? {
            [this.initKey]: value
        } : {
            [this.queryKey]: value
        }
        Object.assign(params, util.cloneDeep(this.params))
        this.paramFormater(params, source)
        return this.fn(params).then(res => (this.listKey ? util.getValueByPath(res.data, this.listKey) : res.data) || []).finally(() => {
            this.loading = false
        })
    }

    querySearch(...args) {
        return querySearch(this, ...args)
    }
}
